import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Select,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import Select2 from "react-select";

const AddEditSession = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    time: "",
    date: "",
    type: "",
    isActive: true,
    subject: "",
    professor: "",
  });
  const handleSelectChangeType = (newValue) => {
    setItem({ ...item, type: newValue });
    setTypeError("");
  };
  const [typeError, setTypeError] = useState("");
  const handleChangeDate = (newValue) => {
    setItem({ ...item, date: newValue });
    setDateError("");
  };
  const [dateError, setDateError] = useState("");
  const handleChangeTime = (newValue) => {
    setItem({ ...item, time: newValue });
    setTimeError("");
  };
  const [timeError, setTimeError] = useState("");
  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);

  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload actionHint={"Accepts jpegs, pngs and svgs"} />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    setItem({
      ...item,
      image:
        validImageTypes.indexOf(files[files.length - 1].type) > 0
          ? window.URL.createObjectURL(files[files.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
    // setIsImageUploading(true);

    // const form_data = new FormData();
    // form_data.append("entity_type", "session");
    // form_data.append("image", files[files.length - 1]);
    // axios
    //   .post("/s3/save-file", form_data)
    //   .then((res) => {
    //     setIsImageUploading(false);
    //     setItem({
    //       ...item,
    //       image:
    //         validImageTypes.indexOf(files[files.length - 1].type) > 0
    //           ? window.URL.createObjectURL(files[files.length - 1])
    //           : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    //     });
    //     imageKey.current = res.data.data.file_key;
    //     setImageError("");
    //   })
    //   .catch((err) => console.log(err));
  };
  const [optionsSubjects, setOptionsSubjects] = useState([]);
  const handleSelectChangeSubject = (newValue) => {
    setItem({ ...item, subject: newValue });
  };
  const [optionsProfessors, setOptionsProfessors] = useState([]);
  const handleSelectChangeProfessor = (newValue) => {
    setItem({ ...item, professor: newValue });
  };
  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseSubjects = "";
    let responseProfessors = "";
    let responseItem = "";
    try {
      responseSubjects = await axios.get(`/subjects`);
      setOptionsSubjects(
        responseSubjects.data.data.data.map((item, index) => {
          return {
            label: item?.name && getFirstNonNullValue(item.name),
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    try {
      responseProfessors = await axios.get(`/professors`);
      setOptionsProfessors(
        responseProfessors.data.data.data.map((item, index) => {
          return {
            label: item?.name && getFirstNonNullValue(item.name),
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    if (props?.type === "edit")
      try {
        responseItem = await axios.get(`/sessions/${id}`);
        setItem({
          type:
            responseItem?.data?.data?.type !== null
              ? String(responseItem?.data?.data?.type)
              : "",
          date: responseItem?.data?.data?.date
            ? responseItem?.data?.data?.date
            : "",
          time: responseItem?.data?.data?.time
            ? responseItem?.data?.data?.time
            : "",
          isActive: responseItem?.data?.data?.is_active ? true : false,
        });
      } catch (error) {
        console.log(error);
      }
  }

  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Session`}
      backAction={{ onAction: () => navigate("/admin/sessions") }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <Select
            label="Type"
            options={[
              { label: "Professor", value: "1" },
              { label: "Subject", value: "2" },
            ]}
            onChange={handleSelectChangeType}
            value={item.type}
            placeholder="Please select"
            error={typeError}
          />
          {item.type === "1" && (
            <FormLayout>
              <Text>Professor</Text>
              <Select2
                options={optionsProfessors}
                onChange={handleSelectChangeProfessor}
                value={item.school}
                placeholder="Please select"
                styles={{
                  // Fixes the overlapping problem of the component
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
              />
            </FormLayout>
          )}
          {item.type === "2" && (
            <FormLayout>
              <Text>Subject</Text>
              <Select2
                options={optionsSubjects}
                onChange={handleSelectChangeSubject}
                value={item.school}
                placeholder="Please select"
                styles={{
                  // Fixes the overlapping problem of the component
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
              />
            </FormLayout>
          )}

          <FormLayout.Group>
            <TextField
              value={item.date}
              onChange={handleChangeDate}
              label="Date"
              type="date"
              error={dateError}
            />
            <TextField
              value={item.time}
              onChange={handleChangeTime}
              label="Time"
              type="time"
              error={timeError}
            />
          </FormLayout.Group>

          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/sessions/${id}`)
                  .then((result) => {
                    navigate("/admin/sessions");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.date || !item.time || item.type === "") {
      !item.date && setDateError("Please enter a date");
      !item.time && setTimeError("Please enter a time");
      item.type === "" && setTypeError("Please enter a type");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.date && form_data.append("date", item.date);
      item.time && form_data.append("time", item.time);
      form_data.append("type", item.type);
      item.type === "1" &&
        form_data.append("professor_id", item.professor.value);
      item.type === "2" && form_data.append("subject_id", item.subject.value);
      form_data.append("is_active", item.isActive ? 1 : 0);
      props?.type === "edit" && form_data.append("_method", "PATCH");
      props.type === "add"
        ? axios
            .post(`/sessions`, form_data)
            .then((result) => {
              navigate("/admin/sessions");
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/sessions/${id}`, form_data)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default AddEditSession;
